<template>
  <div class="questions-wrap">
    <faq-item
      v-for="(item, i) in questions"
      :key="i"
      :item="item"
      :index="i"
      :active="active"
      :openQuestions="openQuestions"
      @item-click-handler="itemClickHandler"
    />
  </div>
</template>

<script>
import FaqItem from "./FaqItem.vue";

export default {
  name: "FaqList",
  components: { FaqItem },
  props: ["questions", "openQuestions"],
  emits: ["click-handler"],
  data() {
    return {
      active: "-1",
    };
  },
  // mounted() {
  //   console.log("Received questions:", this.questions);
  //   console.log("Received openQuestions:", this.openQuestions);
  //   console.log("aaaaaaa");
  // },
  methods: {
    itemClickHandler(id) {
      if (id.toString().includes("_") && this.active.toString().includes("_")) {
        const activeSepId = this.active.toString().split("_");
        const sepId = id.toString().split("_");
        const childId = sepId[1];
        const activeChild = activeSepId[1];

        this.active =
          activeChild == childId ? sepId[0] : `${sepId[0]}_${childId}`;
        return;
      }

      if (
        !id.toString().includes("_") &&
        this.active.toString().includes("_") &&
        id == this.active.toString().split("_")[0]
      ) {
        this.active = -1;
        return;
      }

      if (!id.toString().includes("_") && this.active != id) {
        this.active = id;
        return;
      }

      this.active === id ? (this.active = -1) : (this.active = id);
    },
  },
};
</script>
